import { marketingAnalyticsSettingsSchema } from "@redotech/redo-marketing-common/marketing-analytics-settings";
import * as z from "zod";

export const getMarketingAnalyticsSettings = {
  name: "getMarketingAnalyticsSettings" as const,
  input: z.object({}),
  output: marketingAnalyticsSettingsSchema,
};
